/**
 * Shared password validation rules — used by SignupForm and ResetConfirmForm.
 * Keep in sync with Supabase Auth password policy settings.
 */

// `labelKey` indexes the `auth` message namespace; consumers resolve it via
// useTranslations("auth"). The `test` predicates are the stable logic.
export const PASSWORD_RULES = [
  { id: "length",    labelKey: "ruleLength",    test: (p: string) => p.length >= 10   },
  { id: "uppercase", labelKey: "ruleUppercase", test: (p: string) => /[A-Z]/.test(p) },
  { id: "number",    labelKey: "ruleNumber",    test: (p: string) => /[0-9]/.test(p) },
] as const;

export type PasswordRule = (typeof PASSWORD_RULES)[number];

export function passwordValid(password: string): boolean {
  return PASSWORD_RULES.every((r) => r.test(password));
}
